declare const jQuery: any;
declare const QentaCEE_DataStorage: any;

import { validateForm } from "./form-validation";
import { executeRecaptchaV3 } from "./recaptcha";

export function paymentFormDataContext(config) {
  // Payment Widget
  return {
    $form: null,
    paymentMethod: null,
    triedSubmit: false,
    isSubmitting: false,
    submitButtonText: "Kaufen",
    initialButtonText: "Kaufen",
    errors: {} as any,

    init() {
      this.$form = this.$root as HTMLFormElement;
      // Initialtext des Submit-Buttons kommt aus dem Fluid-Template
      // (z. B. "Bezahlmethode ändern" beim Change-Flow) — sonst "Kaufen".
      const initial = this.$form.dataset.buttonText;
      if (initial && initial.length > 0) {
        this.initialButtonText = initial;
        this.submitButtonText = initial;
      }
      this.$form.addEventListener("submit", ($e: SubmitEvent) => {
        this.triedSubmit = true;
        $e.preventDefault();

        if (!validateForm(this.$form)) {
          this.unlockSubmit();
          return;
        }

        if (!this.paymentMethod) {
          this.unlockSubmit();
          return;
        }

        if (this.isSubmitting) {
          return;
        }

        this.lockSubmit();
        this.storePaymentDataAndSubmit();
      });

      // Kreditkarten-Ablaufdatum: Mobile-Tastatur (inputmode=numeric) hat
      // keinen "/", User können MM/JJ nicht eingeben. Wir formatieren live —
      // nur Ziffern durchlassen und den Trenner nach zwei Ziffern selbst
      // einsetzen. Funktioniert für Tippen, Backspace und Paste.
      const $expiry = this.$form.querySelector<HTMLInputElement>("#creditcard-expiry");
      if ($expiry) {
        $expiry.addEventListener("input", () => {
          const digits = $expiry.value.replace(/\D/g, "").slice(0, 4);
          $expiry.value = digits.length >= 3
            ? digits.slice(0, 2) + "/" + digits.slice(2)
            : digits;
        });
      }
    },

    setPaymentMethod(method) {
      if (this.isSubmitting) {
        return;
      }

      this.errors = {};
      this.paymentMethod = method;
    },

    lockSubmit() {
      this.isSubmitting = true;
      this.submitButtonText = "Wird verarbeitet ...";
    },

    unlockSubmit() {
      this.isSubmitting = false;
      this.submitButtonText = this.initialButtonText;
    },

    async submitForm() {
      const $form = this.$root as HTMLFormElement;
      if (($form.dataset.recaptcha ?? "false") == "true") {
        // Site-Key kommt per data-Attribut aus der Site-Config (env),
        // damit kein Key im JS-Bundle landet und ein Key-Wechsel keinen
        // Rebuild braucht.
        const recaptchaSitekey = $form.dataset.recaptchaSitekey ?? "";
        const action = $form.dataset.recaptchaAction ?? "submit";
        try {
          const token = await executeRecaptchaV3(recaptchaSitekey, action);
          const tokenField = $form.querySelector<HTMLInputElement>("[data-recaptcha-token]");
          if (!tokenField) {
            throw new Error("Missing reCAPTCHA token field.");
          }
          tokenField.value = token;
          HTMLFormElement.prototype.submit.call($form);
        } catch {
          this.unlockSubmit();
        }
        return;
      }
      HTMLFormElement.prototype.submit.call($form);
    },

    storePaymentDataAndSubmit() {
      if (!this.paymentMethod) {
       this.unlockSubmit();
       return;
      }

      // @see https://guides.hobex.at/hosted/seamless/data-storage/
      const dataStorage = new QentaCEE_DataStorage();

      this.errors = {};

      function parseExpiry(input) {
       const value = String(input ?? "").trim();

       if (!value.includes("/")) {
         return null;
       }

       const parts = value.split("/");

       if (parts.length !== 2) {
         return null;
       }

       const m = String(parts[0] ?? "").trim();
       const y = String(parts[1] ?? "").trim();

       if (!m || !y) {
         return null;
       }

       return {
         month: Number(m),
         year: Number(y.length <= 2 ? "20" + y : y),
       };
      }

      let paymentInformation = {} as any;
      let failures = false;

      if (this.paymentMethod === "creditcard") {
        const $inputs = jQuery("#payment-creditcard").find("input");

        $inputs.each(function () {
          let addQuery = true;

          if (jQuery(this).attr("id") === "creditcard-number" && jQuery(this).attr("data-valid") !== "true") {
            addQuery = false;
          }

          if (jQuery(this)[0].checkValidity() && addQuery) {
            jQuery(this).closest(".input-container").find(".input-column").removeClass("error");
            jQuery(this).closest(".input-container").find(".error-message").html("");
          } else {
            failures = true;

            const errorMsg = jQuery(this).attr("data-validation-message") || jQuery(this)[0].validationMessage;

            jQuery(this)
              .closest(".input-container")
              .find(".error-message")
              .html('<p class="error">' + errorMsg + "</p>");
            jQuery(this).closest(".input-container").find(".input-column").addClass("error");
          }
        });

        if (!failures) {
          const holderName = String(jQuery("#creditcard-holder-name").val() ?? "").trim();
          const pan = String(jQuery("#creditcard-number").val() ?? "").replace(/\s/g, "");
          const expiryRaw = String(jQuery("#creditcard-expiry").val() ?? "").trim();
          const cvc = String(jQuery("#creditcard-verify-code").val() ?? "").trim();

          const expiry = parseExpiry(expiryRaw);

          if (!expiry) {
            failures = true;
            jQuery("#creditcard-expiry")
              .closest(".input-container")
              .find(".error-message")
              .html('<p class="error">Ablaufdatum ungültig</p>');
            jQuery("#creditcard-expiry").closest(".input-container").find(".input-column").addClass("error");
          } else {
            paymentInformation.cardholdername = holderName;
            paymentInformation.pan = pan;
            paymentInformation.expirationMonth = expiry.month;
            paymentInformation.expirationYear = expiry.year;
            paymentInformation.cardverifycode = cvc;
          }
        }

        if (!failures) {
          dataStorage.storeCreditCardInformation(paymentInformation, this.storePaymentDataCallback.bind(this));
        } else {
          this.unlockSubmit();
          this.$refs.creditcardFieldset.scrollIntoView({ behavior: "smooth", block: "center" });
        }

        return;
      }

      if (this.paymentMethod === "banktransfer") {
        const $inputs = jQuery("#payment-banktransfer").find("input");
        $inputs.each(function () {
          if (jQuery(this)[0].checkValidity()) {
            jQuery(this).closest(".input-container").find(".input-column").removeClass("error");
            jQuery(this).closest(".input-container").find(".error-message").html("");
            paymentInformation.bankAccountIban = jQuery("#banktransfer-iban").val();
            // paymentInformation.bankBic = "";
            paymentInformation.accountOwner = jQuery("#banktransfer-name").val();
          } else {
            failures = true;
            const errorMsg = jQuery(this).attr("data-validation-message") || jQuery(this)[0].validationMessage;
            jQuery(this)
              .closest(".input-container")
              .find(".error-message")
              .html('<p class="error">' + errorMsg + "</p>");
            jQuery(this).closest(".input-container").find(".input-column").addClass("error");
          }
        });
        if (!failures) {
          dataStorage.storeSepaDdInformation(paymentInformation, this.storePaymentDataCallback.bind(this));
        } else {
          this.unlockSubmit();
          this.$refs.banktransferFieldset.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        return;
      }

      this.submitForm();
    },

    storePaymentDataCallback(response) {
      if (response.getStatus() === 0) {
        this.submitForm();
      } else {
        this.unlockSubmit();
        const errors = response.getErrors();
        for (const error of errors) {
          // const errorCode = error.errorCode;
          const consumerMessage = this.decodeHtmlEntities(error.consumerMessage);
          if (this.paymentMethod === "creditcard") {
            // if (errorCode == 11117 || errorCode == 15117) {
            //   // Security Code
            //   this.errors.cc_csc = consumerMessage;
            // } else if (errorCode == 18116) {
            //   // Expiration Date
            //   this.errors.cc_exp = consumerMessage;
            // }
            this.errors.cc = consumerMessage;
            this.$refs.creditcardFieldset.scrollIntoView({ behavior: "smooth", block: "center" });
          } else if (this.paymentMethod === "banktransfer") {
            // if (errorCode == 15152) {
            //   this.errors.bt_iban = consumerMessage;
            // }
            this.errors.bt = consumerMessage;
            this.$refs.banktransferFieldset.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
    },

    decodeHtmlEntities(s) {
      return String(s ?? "")
        .replace(/&#x([0-9a-f]+);/gi, (_, h) => String.fromCodePoint(parseInt(h, 16)))
        .replace(/&#(\d+);/g, (_, n) => String.fromCodePoint(Number(n)))
        .replace(/&(amp|lt|gt|quot|apos);/g, (_, e) => ({ amp: "&", lt: "<", gt: ">", quot: '"', apos: "'" })[e]);
    },
  } as any;
}
